import * as React from 'react';
import { useGraphQLClient } from '../../../graphql-client';
import { ApolloProvider } from '@apollo/react-hooks';
import BaseComponent, { Props } from './BaseComponent/BaseComponent';

export const Component: React.FunctionComponent<Props> = props => {
	const client = useGraphQLClient();

	return (
		<ApolloProvider client={client}>
			<BaseComponent {...props} />
		</ApolloProvider>
	);
};

export default Component;
